import { Resource } from 'i18next';
import { absoluteUrlTranslations, imageTranslations, mpvIdTranslations } from '@99designs/i18n';
import enauPrdId from './prdIds/en-au.json';
import enusPrdId from './prdIds/en-us.json';
import dadk from './translations/da_dk.json';
import dede from './translations/de_de.json';
import enau from './translations/en_au.json';
import enca from './translations/en_ca.json';
import engb from './translations/en_gb.json';
import enie from './translations/en_ie.json';
import enin from './translations/en_in.json';
import enus from './translations/en_us.json';
import eses from './translations/es_es.json';
import esus from './translations/es_us.json';
import fifi from './translations/fi_fi.json';
import frca from './translations/fr_ca.json';
import frfr from './translations/fr_fr.json';
import itit from './translations/it_it.json';
import nbno from './translations/nb_no.json';
import nlnl from './translations/nl_nl.json';
import ptpt from './translations/pt_pt.json';
import svse from './translations/sv_se.json';

const {
    dadkMpvId,
    dedeMpvId,
    enauMpvId,
    encaMpvId,
    engbMpvId,
    enieMpvId,
    eninMpvId,
    ennzMpvId,
    enusMpvId,
    esesMpvId,
    esusMpvId,
    fifiMpvId,
    frcaMpvId,
    frfrMpvId,
    ititMpvId,
    nbnoMpvId,
    nlnlMpvId,
    ptptMpvId,
    svseMpvId,
} = mpvIdTranslations;

const {
    dadkURLs,
    dedeURLs,
    deatURLs,
    dechURLs,
    enauURLs,
    ennzURLs,
    encaURLs,
    ensgURLs,
    engbURLs,
    enieURLs,
    eninURLs,
    enusURLs,
    esesURLs,
    esusURLs,
    fifiURLs,
    frbeURLs,
    frcaURLs,
    frchURLs,
    frfrURLs,
    itchURLs,
    ititURLs,
    nlbeURLs,
    nbnoURLs,
    nlnlURLs,
    ptptURLs,
    svseURLs,
} = absoluteUrlTranslations;

const {
    dadkImages,
    dedeImages,
    enauImages,
    engbImages,
    enusImages,
    esesImages,
    esusImages,
    fifiImages,
    frcaImages,
    frfrImages,
    ititImages,
    nbnoImages,
    nlnlImages,
    ptptImages,
    svseImages,
} = imageTranslations;

const resources: Resource = {
    'da-dk': {
        translation: {
            ...dadk,
            ...dadkURLs,
            ...dadkMpvId,
            ...dadkImages,
        },
    },
    'de-at': {
        translation: {
            ...dede,
            ...deatURLs,
            ...dedeMpvId,
            ...dedeImages,
        },
    },
    'de-ch': {
        translation: {
            ...dede,
            ...dechURLs,
            ...dedeMpvId,
            ...dedeImages,
        },
    },
    'de-de': {
        translation: {
            ...dede,
            ...dedeURLs,
            ...dedeMpvId,
            ...dedeImages,
        },
    },
    'en-au': {
        translation: {
            ...enau,
            ...enauURLs,
            ...enauMpvId,
            ...enauPrdId,
            ...enauImages,
        },
    },
    'en-ca': {
        translation: {
            ...enca,
            ...encaURLs,
            ...encaMpvId,
            ...enusImages,
        },
    },
    'en-gb': {
        translation: {
            ...engb,
            ...engbURLs,
            ...engbMpvId,
            ...engbImages,
        },
    },
    'en-ie': {
        translation: {
            ...enie,
            ...enieURLs,
            ...enieMpvId,
            ...engbImages,
        },
    },
    'en-in': {
        translation: {
            ...enin,
            ...eninURLs,
            ...eninMpvId,
            ...engbImages,
        },
    },
    'en-nz': {
        translation: {
            ...enau,
            ...ennzURLs,
            ...ennzMpvId,
            ...enauImages,
        },
    },
    'en-sg': {
        translation: {
            ...engb,
            ...ensgURLs,
            ...engbMpvId,
            ...engbImages,
        },
    },
    'en-us': {
        translation: {
            ...enus,
            ...enusURLs,
            ...enusMpvId,
            ...enusPrdId,
            ...enusImages,
        },
    },
    'es-es': {
        translation: {
            ...eses,
            ...esesURLs,
            ...esesMpvId,
            ...esesImages,
        },
    },
    'es-us': {
        translation: {
            ...esus,
            ...esusURLs,
            ...esusMpvId,
            ...esusImages,
        },
    },
    'fi-fi': {
        translation: {
            ...fifi,
            ...fifiURLs,
            ...fifiMpvId,
            ...fifiImages,
        },
    },
    'fr-be': {
        translation: {
            ...frfr,
            ...frbeURLs,
            ...frfrMpvId,
            ...frfrImages,
        },
    },
    'fr-ca': {
        translation: {
            ...frca,
            ...frcaURLs,
            ...frcaMpvId,
            ...frcaImages,
        },
    },
    'fr-ch': {
        translation: {
            ...frfr,
            ...frchURLs,
            ...frfrMpvId,
            ...frfrImages,
        },
    },
    'fr-fr': {
        translation: {
            ...frfr,
            ...frfrURLs,
            ...frfrMpvId,
            ...frfrImages,
        },
    },
    'it-ch': {
        translation: {
            ...itit,
            ...itchURLs,
            ...ititMpvId,
            ...ititImages,
        },
    },
    'it-it': {
        translation: {
            ...itit,
            ...ititURLs,
            ...ititMpvId,
            ...ititImages,
        },
    },
    'nb-no': {
        translation: {
            ...nbno,
            ...nbnoURLs,
            ...nbnoMpvId,
            ...nbnoImages,
        },
    },
    'nl-be': {
        translation: {
            ...nlnl,
            ...nlbeURLs,
            ...nlnlMpvId,
            ...nlnlImages,
        },
    },
    'nl-nl': {
        translation: {
            ...nlnl,
            ...nlnlURLs,
            ...nlnlMpvId,
            ...nlnlImages,
        },
    },
    'pt-pt': {
        translation: {
            ...ptpt,
            ...ptptURLs,
            ...ptptMpvId,
            ...ptptImages,
        },
    },
    'sv-se': {
        translation: {
            ...svse,
            ...svseURLs,
            ...svseMpvId,
            ...svseImages,
        },
    },
};

export default resources;
